// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gateway-detail-gateway-detail-tabs-dca54 .ant-tabs-tab a{color:var(--color-gray-9)}.gateway-detail-gateway-detail-tabs-dca54 .ant-tabs-tab a:hover{color:var(--link-color)}.gateway-detail-gateway-detail-tabs-dca54 .ant-tabs-tab-active a{color:var(--link-color)}.gateway-detail-gateway-detail-tabs-dca54 .acuicon-outlined-editing-square{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gateway-detail-tabs": "gateway-detail-gateway-detail-tabs-dca54",
	"gatewayDetailTabs": "gateway-detail-gateway-detail-tabs-dca54"
};
export default ___CSS_LOADER_EXPORT___;
